import React, { useEffect } from 'react';
import classNames from 'classnames/bind';
import { Image } from '@thd-olt-component-react/image';
import styles from './paint-delivery-banner.module.scss';

const cx = classNames.bind(styles);

const PaintDeliveryBanner = () => {
  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('paint-delivery-banner.ready');
  }, []);

  return (
    <div className={cx('paint-delivery-banner')}>
      <Image
        className={cx('paint-delivery-banner__image')}
        src="https://assets.homedepot-static.com/p/static/images/paint/8-ounce-tile.png"
        alt="Paint Sample Can"
      />
      <div className={cx('paint-delivery-banner__message')}>
        <span className={cx('paint-delivery-banner__message', 'message__highlight')}>Free Delivery&nbsp;</span>
        on 8oz. paint samples every day!
      </div>
    </div>
  );
};

PaintDeliveryBanner.displayName = 'PaintDeliveryBanner';

export { PaintDeliveryBanner };
